import * as React from 'react';
import { SVGProps } from 'react';

const SvgJenkins = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="jenkins_svg__svg2"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 20 20"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {
        '.jenkins_svg__st0,.jenkins_svg__st3,.jenkins_svg__st4{fill-rule:evenodd;clip-rule:evenodd;fill:#d33833}.jenkins_svg__st3,.jenkins_svg__st4{fill:#f0d6b7}.jenkins_svg__st4{fill:#335061}.jenkins_svg__st6{fill:#dcd9d8}.jenkins_svg__st6,.jenkins_svg__st7{fill-rule:evenodd;clip-rule:evenodd}.jenkins_svg__st7,.jenkins_svg__st8{fill:#f7e4cd}.jenkins_svg__st9{fill:#49728b}.jenkins_svg__st10,.jenkins_svg__st9{fill-rule:evenodd;clip-rule:evenodd}.jenkins_svg__st10,.jenkins_svg__st11{fill:#fff}.jenkins_svg__st12{fill:none;stroke:#d33833;stroke-width:.1603;stroke-miterlimit:5}.jenkins_svg__st13,.jenkins_svg__st14,.jenkins_svg__st15,.jenkins_svg__st16{fill-rule:evenodd;clip-rule:evenodd;fill:#ef3d3a}.jenkins_svg__st14,.jenkins_svg__st15,.jenkins_svg__st16{fill:#231f20}.jenkins_svg__st15,.jenkins_svg__st16{fill:#81b0c4}.jenkins_svg__st16{fill:#1d1919}'
      }
    </style>
    <g id="jenkins_svg__g10" transform="matrix(1.25 0 0 -1.25 0 312)">
      <g id="jenkins_svg__g3393">
        <path
          id="jenkins_svg__path22"
          className="jenkins_svg__st0"
          d="M13.6 241.9c0-3.2-2.5-5.7-5.6-5.7-3.1 0-5.6 2.6-5.6 5.7 0 3.2 2.5 5.7 5.6 5.7 3.1 0 5.6-2.5 5.6-5.7"
        />
        <path
          id="jenkins_svg__path24"
          d="M2.6 240.5s-.4 6 5.1 6.2l-.4.6-3-1-.9-1-.7-1.4-.4-1.7.1-1.1"
          style={{
            fill: '#ef3d3a',
          }}
        />
        <path
          id="jenkins_svg__path26"
          d="M4.2 245.8c-1-1-1.6-2.4-1.6-3.9s.6-2.9 1.6-3.9 2.3-1.6 3.8-1.6 2.9.6 3.8 1.6c1 1 1.6 2.4 1.6 3.9s-.6 2.9-1.6 3.9-2.3 1.6-3.8 1.6-2.9-.6-3.8-1.6zm-.3-8.1c-1 1.1-1.7 2.5-1.7 4.2 0 1.6.6 3.1 1.7 4.2 1 1.1 2.5 1.7 4.1 1.7 1.6 0 3-.7 4.1-1.7 1-1.1 1.7-2.5 1.7-4.2 0-1.6-.6-3.1-1.7-4.2-1-1.1-2.5-1.7-4.1-1.7-1.6 0-3 .6-4.1 1.7"
          style={{
            fill: '#231f20',
          }}
        />
        <path
          id="jenkins_svg__path28"
          className="jenkins_svg__st3"
          d="m10.4 241.9-.9-.1-1.2-.1H6.9l-.6.2-.5.5-.4 1.1-.1.2-.5.2-.3.5-.2.6.2.6.6.2.4-.2.2-.5H6l.1.1-.1.6v.6l.1.9v.5l.4.6.7.5 1.2.5 1.3-.2 1.2-.8.5-.9.3-.6.1-1.5-.3-1.3-.5-1.2-.4-.6"
        />
        <path
          id="jenkins_svg__path30"
          className="jenkins_svg__st4"
          d="m9.6 238.2-3-.2v-.5l.3-1.8-.1-.1-2.1.7-.1.3-.4 2.4-.5 1.5-.1.3 1.7 1.2.5.2.5-.6.4-.4.5-.1.2-.1.3-1.1.2-.2.5.2-.4-.7 1.9-.9-.3-.1"
        />
        <path
          id="jenkins_svg__path32"
          d="m4.6 245.6.6.2.4-.2.2-.5h.3l.1.3-.2.5.1 1.2-.1.6.4.4.8.7-.2.4-1.2-.6-.5-.4-.3-.6-.4-.6-.1-.7.1-.7"
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            fill: '#6d6b6d',
          }}
        />
        <path
          id="jenkins_svg__path34"
          className="jenkins_svg__st6"
          d="M5.4 247.6s.3.8 1.6 1.2.1.3.1.3l-1.4-.5-.5-.6-.2-.4h.4"
        />
        <path
          id="jenkins_svg__path36"
          className="jenkins_svg__st6"
          d="M4.8 245.8s-.4 1.5 1.3 1.7l-.1.2-1.2-.3-.3-1.1.1-.7.2.2"
        />
        <path
          id="jenkins_svg__path38"
          className="jenkins_svg__st7"
          d="m5.5 243.8.3.3s.1 0 .1-.2c0-.1.1-1.5 1-2.2.1-.1-.7.1-.7.1l-.7 1.1"
        />
        <path
          id="jenkins_svg__path40"
          className="jenkins_svg__st7"
          d="M9.4 244.2s0 .6.2.6.2-.2.2-.2-.4-.3-.4-.4"
        />
        <path
          id="jenkins_svg__path42"
          className="jenkins_svg__st8"
          d="M11.2 246.6s-.4-.1-.4-.4c0-.3.4-.1.4 0"
        />
        <path
          id="jenkins_svg__path44"
          className="jenkins_svg__st8"
          d="M8.6 246.5s-.5-.1-.5-.4c0-.3.5-.3.7-.1"
        />
        <path
          id="jenkins_svg__path46"
          className="jenkins_svg__st7"
          d="M5.7 245.2s-.8.5-.9 0c-.1-.5-.3-.8.1-1.3l-.2.1-.3.7-.1.6.5.5h.6l.3-.3v-.3"
        />
        <path
          id="jenkins_svg__path48"
          className="jenkins_svg__st7"
          d="M6.1 246.5s.4 1.9 2.2 2.2c1.5.3 2.3-.1 2.6-.4 0 0-1.3 1.6-2.6 1.1s-2.2-1.4-2.2-2v-.9"
        />
        <path
          id="jenkins_svg__path50"
          className="jenkins_svg__st7"
          d="M11 248.1s-.6 0-.6-.5v-.2s.5.6.8.3"
        />
        <path
          id="jenkins_svg__path52"
          className="jenkins_svg__st7"
          d="M8.3 247.4s-.1.9-.8.4c-.5-.3-.4-.8-.3-.9.1-.1.1-.3.1-.1.1.1 0 .5.3.6.2 0 .6.2.7 0"
        />
        <path
          id="jenkins_svg__path54"
          className="jenkins_svg__st9"
          d="m6.3 241.6-2-.9s.8-3.3.4-4.3l-.3.1v1.3l-.6 2.4-.2.7 2.1 1.4.6-.7"
        />
        <path
          id="jenkins_svg__path56"
          className="jenkins_svg__st9"
          d="m6.5 239.7.3-.3v-1.3h-.3v1.5"
        />
        <path id="jenkins_svg__path58" className="jenkins_svg__st9" d="M6.5 237.9h-1l.3-.2.7-.1" />
        <path
          id="jenkins_svg__path60"
          className="jenkins_svg__st4"
          d="M9.8 238.1h.8l.2-2-.8-.1-.2 2.1"
        />
        <path
          id="jenkins_svg__path62"
          className="jenkins_svg__st4"
          d="m10 238.1 1.2.1s.5 1.2.5 1.3.4 1.8.4 1.8l-1 1-.2.2-.5-.5v-2l-.4-1.9"
        />
        <path
          id="jenkins_svg__path64"
          className="jenkins_svg__st9"
          d="m10.6 238.3-.7-.1.1-.6c.3-.1.7.2.7.2"
        />
        <path
          id="jenkins_svg__path66"
          className="jenkins_svg__st9"
          d="m10.6 242 1.5-1.1v.5l-1.1 1-.4-.4"
        />
        <path
          id="jenkins_svg__path68"
          className="jenkins_svg__st10"
          d="m7.3 233.9-.4 1.8-.3 1.3v1l2 .1h1.2l-.1-2.2.2-1.7v-.3l-1.6-.1-1 .1"
        />
        <path
          id="jenkins_svg__path70"
          className="jenkins_svg__st6"
          d="M9.5 238.2s-.1-2.2.2-3.8c0 0-.6-.4-1.6-.5l1.8.1.2.1-.3 3.5-.1.7"
        />
        <path
          id="jenkins_svg__path72"
          className="jenkins_svg__st10"
          d="m10.8 236.4.8.2 1.6.1.2.7-.4 1.3-.5.1-.7-.2-.7-.3-.3.1-.3-.1"
        />
        <path
          id="jenkins_svg__path74"
          className="jenkins_svg__st6"
          d="M10.8 236.8s.6.3.6.2l-.2 1.2.3.1s.2-1.1.2-1.2c0 0 1.2-.1 1.3-.1 0 0 .3.5.2 1l.2-.7v-.4l-.3-.5-.4-.1h-.6l-.2.3-.7-.1-.2-.1"
        />
        <path
          id="jenkins_svg__path76"
          className="jenkins_svg__st11"
          d="m10 238.3-.5 1.2-.5.7s.1.3.3.3h.5l.5-.2v-.8l-.3-1.2"
        />
        <path
          id="jenkins_svg__path78"
          className="jenkins_svg__st6"
          d="M10.1 238.7s-.6 1.2-.6 1.3c0 0 .1.3.3.2s.5-.2.5-.2v.4l-.7.1H9l.8-2h.2"
        />
        <path
          id="jenkins_svg__path80"
          className="jenkins_svg__st11"
          d="m7.5 241.5-.6.1-.6.2v-.2l.3-.3.9-.4"
        />
        <path
          id="jenkins_svg__path82"
          className="jenkins_svg__st6"
          d="M6.5 241.5s.7-.3.9-.2v-.3l-.6.1-.3.4"
        />
        <path
          id="jenkins_svg__path84"
          className="jenkins_svg__st0"
          d="M10.8 240.4c-.4 0-.7.1-1 .1v.3c.1.1.2.1.3.1-.1.1-.3.1-.4 0 0 .1 0 .1-.1.2.2.1.7.6 1 .4.1-.1.2-.5.2-.7.1-.1.1-.3 0-.4"
        />
        <path
          id="jenkins_svg__path86"
          className="jenkins_svg__st12"
          d="M10.8 240.4c-.4 0-.7.1-1 .1v.3c.1.1.2.1.3.1-.1.1-.3.1-.4 0 0 .1 0 .1-.1.2.2.1.7.6 1 .4.1-.1.2-.5.2-.7.1-.1.1-.3 0-.4z"
        />
        <path
          id="jenkins_svg__path88"
          className="jenkins_svg__st0"
          d="M9.1 241c-.1-.2-.3-.2-.4-.2.2 0 .3-.1.5-.1v-.2c-.2-.1-.4-.4-.6-.5-.1-.1-.5-.2-.6-.2-.1 0-.1.1-.1.2-.1.2-.2.5-.2.7 0 .3 0 .9.3.8.3-.1.6-.2.8-.3 0-.1.1-.2.3-.2"
        />
        <path
          id="jenkins_svg__path90"
          className="jenkins_svg__st12"
          d="M9.1 241c-.1-.2-.3-.2-.4-.2.2 0 .3-.1.5-.1v-.2c-.2-.1-.4-.4-.6-.5-.1-.1-.5-.2-.6-.2-.1 0-.1.1-.1.2-.1.2-.2.5-.2.7 0 .3 0 .9.3.8.3-.1.6-.2.8-.3 0-.1.1-.2.3-.2z"
        />
        <path
          id="jenkins_svg__path92"
          className="jenkins_svg__st0"
          d="M9.3 240.6c0 .2-.1.2-.1.4.5.3.6-.5.1-.4"
        />
        <path
          id="jenkins_svg__path94"
          className="jenkins_svg__st12"
          d="M9.3 240.6c0 .2-.1.2-.1.4.5.3.6-.5.1-.4z"
        />
        <path
          id="jenkins_svg__path96"
          className="jenkins_svg__st13"
          d="M10 240.5s-.1.2 0 .3c.1.1.2 0 .3.1.1.1 0 .2 0 .3 0 .1.1.1.2.2.1 0 .4.1.4 0l-.1.4-.3.1-.8-.5v-.7"
        />
        <path
          id="jenkins_svg__path98"
          className="jenkins_svg__st13"
          d="M7.8 239.8c0 .3-.1.7-.1 1 0 .5.1.4.6.4.1 0 .4-.1.4-.1.1-.2-.2-.2.1-.4.3-.2.8.1.7.4-.1.1-.3 0-.4.1-.2.1-.3.2-.5.3-.2.1-.7.3-.9.1-.7-.4-.1-1.4.1-1.8"
        />
        <path
          id="jenkins_svg__path100"
          className="jenkins_svg__st14"
          d="M8.3 247.4c-.6.1-.9-.2-1-.6-.2 0-.1.3-.1.4.1.3.5.7.9.6.1-.1.3-.3.2-.4"
        />
        <path
          id="jenkins_svg__path102"
          className="jenkins_svg__st14"
          d="M11.2 246.7c.2-.3.3-.6.4-.8-.1-.3-.8-.5-.8 0 .2.1.4 0 .6.1-.1.2-.2.4-.2.7"
        />
        <path
          id="jenkins_svg__path104"
          className="jenkins_svg__st14"
          d="M8.6 246.7c.1-.2.2-.5.3-.6.1-.1.2-.2.2-.4 0-.1-.1-.2-.2-.2-.3-.1-.9 0-.7.3.2 0 .5-.1.7 0-.1.2-.4.6-.3.9"
        />
        <path
          id="jenkins_svg__path106"
          className="jenkins_svg__st14"
          d="M11.1 244.4c-.4-.3-.9-.6-1.6-.5-.1.1-.2.4-.1.6.1-.1 0-.4.2-.4.4-.1.8.2 1.1.3.2.3 0 .4-.2.6-.3.4-.7.9-.7 1.4.1.1.1-.1.2-.2.2-.4.6-.9.9-1.2l.2-.2c.1-.1-.1-.3 0-.4"
        />
        <path
          id="jenkins_svg__path108"
          className="jenkins_svg__st14"
          d="M5.6 244.6c-.1.1-.2.4-.3.4-.2 0-.2-.4-.2-.7-.2.1-.2.6-.1.8-.1.1-.2-.1-.3-.1.1.7 1 .3.9-.4"
        />
        <path
          id="jenkins_svg__path110"
          className="jenkins_svg__st14"
          d="M11.3 244.1c-.2-.4-.5-.8-1-.8v.4c.4 0 .7.2 1 .4"
        />
        <path
          id="jenkins_svg__path112"
          className="jenkins_svg__st14"
          d="M8.6 243.8c.4-.2 1-.2 1.5-.2v-.4c-.6 0-1.3.2-1.5.6"
        />
        <path
          id="jenkins_svg__path114"
          className="jenkins_svg__st14"
          d="M8.5 243.5c.3-.6 1.1-.6 1.8-.5 0-.1-.1-.2-.2-.2-.2-.1-.9-.2-1.2 0-.2.1-.3.4-.5.5.1 0-.2.2.1.2"
        />
        <path
          id="jenkins_svg__path116"
          className="jenkins_svg__st15"
          d="m11 240-.9-1.5c.1.4.2 1.2.2 1.7.3.2.6 0 .7-.2"
        />
        <path
          id="jenkins_svg__path118"
          className="jenkins_svg__st14"
          d="M12.6 238.2c-.3-.1-.6-.4-.9-.4.2.3.5.4.9.4"
        />
        <path
          id="jenkins_svg__path120"
          className="jenkins_svg__st14"
          d="M12.8 237.7c-.3 0-.6-.1-.9 0 .1.1.6 0 .9 0"
        />
        <path
          id="jenkins_svg__path122"
          className="jenkins_svg__st14"
          d="M12.9 237.2h-1c.2.2.8.1 1 0"
        />
        <path
          id="jenkins_svg__path124"
          className="jenkins_svg__st6"
          d="M10.5 236c0-.4.2-.8.2-1.2-.2-.1-.3-.1-.5-.1 0 .4-.1.9 0 1.2 0 0 .2.1.3.1"
        />
        <path
          id="jenkins_svg__path126"
          className="jenkins_svg__st3"
          d="M10 241.6c-.2-.1-.3-.2-.4-.3-.3 0-.5 0-.7.2.3-.1.7.1 1.1.1"
        />
        <path
          id="jenkins_svg__path128"
          className="jenkins_svg__st15"
          d="M8.2 239.2c.1.4.5.6.8.9.4-.4.6-1 .8-1.6-.6.2-1.2.5-1.6.7"
        />
        <path
          id="jenkins_svg__path130"
          className="jenkins_svg__st14"
          d="M10.1 235.9v-1.2c.2 0 .3 0 .5.1 0 .4-.1.8-.2 1.2 0 0-.2-.1-.3-.1zm-3.5 2c.1-1.4.4-2.5.8-3.7.9-.3 1.9-.3 2.7 0-.1.7-.1 1.5-.2 2.2-.1.5 0 1.1-.1 1.7-1 .1-2.3-.1-3.2-.2zm3.4.1c0-.6 0-1.2.1-1.7.2 0 .4.1.6.1-.1.6-.1 1.2-.2 1.7-.2-.1-.3-.1-.5-.1zm1.1.1h-.3c0-.5.2-1 .2-1.5.2 0 .2.1.4.1 0 .4 0 1-.3 1.4zm1.8-1.6c.3.1.5.5.5.9-.1.3-.2.8-.3 1-.1.1-.3.3-.5.2-.3-.2-.9-.3-1.1-.5.1-.4.1-.9.2-1.4.4 0 .9.1 1.2 0-.2-.1-.5-.1-.7-.2 0-.1.4-.1.7 0zm-3.1 2c-.2.6-.4 1.1-.8 1.6-.3-.2-.7-.4-.8-.9.4-.2 1-.5 1.6-.7zm.5 1.7c0-.6-.1-1.3-.2-1.7.4.4.6 1 .9 1.5-.1.2-.4.4-.7.2zm-.6.3c-.1 0-.2-.2-.4-.1l-.1-.1c.4-.5.6-1.1.8-1.7.2.5.1 1.1.2 1.7-.2-.1-.4.2-.5.2zm-.4.5c0-.2 0-.2.1-.4.4-.1.3.7-.1.4zm-.6.2c-.2.1-.6.3-.8.3-.4.1-.3-.5-.3-.8 0-.3.1-.5.2-.7 0-.1 0-.2.1-.2s.5.1.6.2c.2.1.4.3.6.5v.2c-.1.1-.3.1-.5.1.1.1.3.1.4.1v.1c-.1 0-.2.1-.3.2zm-2.1.4c-.2-.2.5-.4.7-.5 0 .1.1.2.1.3-.3.1-.7.1-.8.2zm2.2-.1c.2-.2.4-.3.7-.2.1.1.3.2.4.3-.3 0-.7-.2-1.1-.1zm2.1-.6c0 .2-.1.6-.2.7-.3.2-.8-.3-1-.4 0-.1.1-.1.1-.2h.4c-.1 0-.3 0-.3-.1v-.3c.3-.1.6-.1 1-.1v.4zm-4.7.5c-.1 0-.5.6-.5.5-.7-.3-1.4-.8-2-1.2.6-1.2.8-2.7.8-4.1.6-.3 1.2-.7 2.1-.8-.1.7-.2 1.4-.3 2-.2.1-.5 0-.7 0 0 .2.3.1.3.3 0 .1-.2.1-.1.3.2-.1.2-.2.4-.2.2.3 0 1 0 1.2 0 .1 0 .3.1.3s0-.7 0-.9c0-.3 0-.5.1-.7.9.1 1.7.2 2.6.2-.2.1-.4.2-.7.3-.1.1-.6.2-.6.4-.1.2.2.3.2.5-.4-.2-.5.2-.6.5-.1.3-.1.5-.2.7-.1.3-.5.5-.9.7zm4.4.5c.6.3.7-1.1.5-1.5 0-.1.2-.2.2-.3-.3-.6-.7-1.1-1-1.7.3.2.6 0 .9.1.1 0 .2.3.3.5.2.5.5 1.2.6 1.7 0 .1.1.4.1.5 0 .2-.3.3-.4.4l-.6.6c-.3-.1-.6-.2-.6-.3zm-5.7 5.2c-.3-.3-.2-.9-.2-1.3.5.3 1.2 0 1.2-.6.2 0 .1.3 0 .5-.1.6.2 1.3 0 1.9-.4 0-.7-.2-1-.5zm2 1.8c-.6-.2-1.5-.6-1.7-1.2.2 0 .3.1.5.1H6c.2 0 .3.4.5.6.1.1.3.2.4.3 0 .1.1.1 0 .2.1 0 0 .1 0 0zm3.3-.1c-.7.4-1.8.7-2.5.3-.6-.3-1.3-.8-1.6-1.3.2-.6-.1-1.1-.1-1.7 0-.3.1-.6.2-.9-.1-.2-.3-.2-.5-.2-.1.3-.2.6-.5.7-.4 0-.8-.3-.8-.7 0-.4.3-1.2.9-1.1.2 0 .2.2.5.2.1-.2-.2-.3-.2-.5v-.3c.1-.4.3-.9.5-1.2.3-.4.8-.4 1.3-.5.1.2.5.2.7.1-.3.1-.5.4-.8.6-.3.3-.5.6-.5.9.5-.7.9-1.2 1.7-1.5.7-.2 1.4.1 1.9.5.2.1.3.4.5.6.6.8.8 1.9.8 3 0 .5 0 .9-.2 1.2-.2.3-.7.6-1 .3-.1.3.3.5.6.4-.2.4-.5.9-.9 1.1zm1.3-10.3c.5.3 1.5.7 1.8 0 .1-.3.3-.7.3-1 .1-.4-.1-1.2-.5-1.3-.3-.1-.7-.1-1.1 0 0 0-.1.1-.1.2-.3 0-.6 0-.8-.1 0-.2-.1-.2-.3-.3-.1-.4.2-.9.1-1.3-.1-.3-.4-.3-.6-.3v-.4c-.1-.2-.3-.3-.5-.3-.8-.1-1.9-.1-2.6.1-.2.5-.4 1.1-.5 1.7-.7-.1-1.3.3-1.8.6-.2.1-.4.1-.5.3-.1.1 0 .4-.1.7 0 .7-.1 1.3-.3 2l-.3.9-.3.9c-.1.4.3.4.6.6.4.3.7.4 1.1.7.1.1.5.3.5.3.1.2-.1.4-.2.5-.1.2-.1.4-.2.6-.3.1-.6.3-.8.5-.3.4-.4 1.1-.2 1.6 0 0 .1.1.1.2s0 .3-.1.4c0 .7.1 1.3.6 1.5.2.8.9 1 1.5 1.4.2.1.5.2.8.3 1 .4 2.5.3 3.3-.3.3-.3.9-.8 1.1-1.2.5-1 .5-2.8.1-4.1 0-.2-.1-.4-.2-.6-.1-.1-.3-.4-.3-.6 0-.1.5-.5.6-.6.2-.2.5-.4.5-.6 0-.2-.1-.5-.2-.8-.1-.8-.3-1.5-.5-2.2"
        />
        <path
          id="jenkins_svg__path132"
          className="jenkins_svg__st7"
          d="M8 243.7s.2.1.4 0c0 0-.3 0-.2-.5h-.1s-.1.4-.1.5"
        />
        <path
          id="jenkins_svg__path134"
          className="jenkins_svg__st16"
          d="M9.9 240c0-.1-.1-.1-.1-.1-.1 0-.1.1-.1.1l.1.1s.1 0 .1-.1"
        />
        <path
          id="jenkins_svg__path136"
          className="jenkins_svg__st16"
          d="M10 239.5c0-.1-.1-.1-.1-.1-.1 0-.1.1-.1.1l.1.1c.1 0 .1-.1.1-.1"
        />
      </g>
    </g>
  </svg>
);

export default SvgJenkins;
